import {
    getOrganization,
    listOrganizations
} from './queries';
import {
    createOrganization,
    deleteOrganization,
    updateOrganization,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';

import {
    CreateOrganization,
    DeleteOrganization,
    GetOrganization,
    ListOrganizations,
    Organization,
    UpdateOrganization
} from "../types.ts";
import {generateClient} from "aws-amplify/api";


const client = generateClient();

export const fetchRecords = async (filter: object) => {
    const response = await client.graphql<GraphQLQuery<ListOrganizations>>({
                                                                               query: listOrganizations,
                                                                               variables: {
                                                                                   filter: filter
                                                                               },
                                                                           });
    return response.data?.listOrganizations.items;
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetOrganization>>({
                                                                             query: getOrganization,
                                                                             variables: {id: id},
                                                                         });
    return response.data?.getOrganization;
};

export const add = async (payload: object) => {
    const response = await client.graphql<GraphQLQuery<CreateOrganization>>({
                                                                                query: createOrganization,
                                                                                variables: {input: payload},
                                                                            });
    return response.data?.createOrganization;
};

export const update = async (_id: string, record: Organization) => {
    delete record.created;
    delete record.updated;
    delete record.createdByUsername

    const response = await client.graphql<GraphQLQuery<UpdateOrganization>>({
                                                                                query: (updateOrganization),
                                                                                variables: {input: record},
                                                                            });
    return response.data?.updateOrganization;
};

export const deleteRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<DeleteOrganization>>({
                                                                                query: (deleteOrganization),
                                                                                variables: {input: {id: id}},
                                                                            });
    return response.data?.deleteOrganization;
};
